import React, { useState, forwardRef, useContext, useEffect } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";

// @material-ui/core components
import {
  makeStyles,
  createTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import {
  Search,
  Cancel,
  Layers,
  AddCircle,
  PersonAdd,
  SendOutlined,
  ScheduleOutlined,
  HowToReg,
  VpnKey,
  Edit,
} from "@material-ui/icons";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import MaterialTable, { MTableBodyRow } from "material-table";
import { Grid, Button, LinearProgress, Box, Tooltip } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import format from "date-fns/format";

import NewTestMain from "views/dialog/NewTestMain";
import ViewTest from "views/dialog/ViewTest";
import Questions from "views/dialog/Questions";
import EditTest from "views/dialog/EditTests";
import EnableApplicantTest from "views/dialog/EnableApplicantTest";
import TestsQuestions from "views/AdminInstitution/TestsQuestions";
import ChangeStatusTest from "views/dialog/ChangeStatusTest";
import DisableTest from "views/dialog/DisableTest";
import ViewApplicantTest from "views/dialog/ViewApplicantTest";
import TestPassWord from "views/dialog/TestPassWord";

import { cardBodyStyle } from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

const useStyles2 = makeStyles({
  tableRow: { "&:hover": { backgroundColor: "rgb(237, 247, 237)!important" } },
});

const theme = createTheme({
  overrides: {
    MuiIconButton: {
      root: {
        padding: 4,
      },
    },
  },
});

export default function Test() {
  const classes = useStyles();
  const tableRef = React.createRef();
  const classes2 = useStyles2();

  const [openView, setOpenView] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openNew, setOpenNew] = useState(false);
  const [openEnableQuestion, setOpenEnableQuestion] = useState(false);
  const [idRow, setIdRow] = useState("");
  const [openApplicants, setOpenApplicants] = useState(false);
  const [openTestQuestion, setOpenTestQuestion] = useState(false);
  const [openDesHabilitar, setOpenDesHabilitar] = useState(false);
  const [openChangeStatus, setOpenChangeStatus] = useState(false);
  const [activatePhoto, setActivatePhoto] = useState(false);
  const [activateApplicantreport, setActivateApplicantreport] = useState(false);
  const [openApplicantsTests, setOpenApplicantsTests] = useState(false);
  const [openPassword, setOpenPassword] = useState(false);
  const [passwordRow, setPasswordRow] = useState(null);

  let keyAuthorization = localStorage.getItem("Session");
  const accountId = localStorage.getItem("account_id");
  const { urlServices, keyAplication } = useContext(UrlServicesContext);

  const tableIcons = {
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  };

  const [state] = useState({
    columns: [
      {
        title: "Prueba",
        field: "name",
        width: "30%",
        render: (rowData) => <b>{rowData.name}</b>,
        cellStyle: {
          border: "1px solid rgb(241, 241, 241)",
          fontSize: 12,
        },
      },
      {
        title: "Cargo",
        field: "testjob.name",
        width: "25%",
        render: (rowData) => rowData.testjob[0].name,
        cellStyle: {
          border: "1px solid rgb(241, 241, 241)",
          fontSize: 12,
        },
      },
      {
        title: "Preguntas",
        field: "name",
        render: (rowData) => (
          <Button
            className={classes.buttonSubmit1}
            onClick={() => OpenTestQuestion(rowData)}
            startIcon={<Search style={{ fontSize: 14 }} />}
          >
            {rowData.question.length}
          </Button>
        ),
        width: "1%",
        cellStyle: {
          textAlign: "center",
          border: "1px solid rgb(241, 241, 241)",
          fontSize: 12,
        },
      },
      {
        title: "Registrado",
        render: (rowData) => format(new Date(rowData.createdAt), "dd-MM-yyyy"),
        width: "10%",
        cellStyle: {
          border: "1px solid rgb(241, 241, 241)",
          fontSize: 12,
          textAlign: "center",
        },
      },
      {
        title: "Estado",
        field: "status",
        render: (rowData) => {
          const text =
            rowData.status === 1
              ? "FINALIZAR"
              : rowData.status === 99
                ? "PUBLICAR"
                : "FINALIZADO";
          const color =
            rowData.status === 1
              ? "#024242"
              : rowData.status === 99
                ? "orange"
                : "";
          return rowData.status === 2 ? (
            <Alert
              icon={false}
              severity="success"
              style={{ fontSize: 10, fontWeight: "bold" }}
            >
              FINALIZADO
            </Alert>
          ) : (
            <>
              <Button
                variant="contained"
                style={{
                  fontSize: 10,
                  background: color,
                  color: "#fff",
                  fontWeight: "bold",
                  padding: "4px 10px",
                }}
                endIcon={
                  rowData.status === 99 ? <SendOutlined /> : <ScheduleOutlined />
                }
                onClick={() =>
                  publishSend(rowData, rowData.status === 99 ? 1 : 2)
                }
              >
                {text}
              </Button>
              <Box
                style={{
                  display: rowData.status === 99 ? "none" : "block",
                  marginTop: 5,
                }}
              >
                <b>En proceso</b>
                <LinearProgress />
              </Box>
            </>
          );
        },
        width: "1%",
        cellStyle: {
          textAlign: "CENTER",
          border: "1px solid rgb(241, 241, 241)",
          fontSize: 12,
        },
      },
      {
        title: "Agregar",
        field: "id",
        render: (rowData) => (
          <Button
            className={classes.buttonSubmit4}
            onClick={() => OpenQuestion(rowData)}
            disabled={
              rowData.status === 1
                ? true
                : rowData.status === 99
                  ? false
                  : true
            }
            startIcon={<AddCircle />}
          >
            preguntas
          </Button>
        ),
        width: "1%",
        cellStyle: {
          textAlign: "CENTER",
          border: "1px solid rgb(241, 241, 241)",
          fontSize: 10,
        },
        sorting: false,
      },
      {
        title: "Acciones",
        width: "90px",
        cellStyle: {
          width: "90px",
          minWidth: "90px",
          border: "1px solid rgb(241, 241, 241)",
          textAlign: "center",
          padding: "4px",
        },
        render: (rowData) => (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr 1fr",
              gap: "5px",
            }}
          >
            {/* Candidatos */}
            {(rowData.status === 1 || rowData.status === 2) && (
              <Tooltip title="Candidatos">
                <HowToReg
                  style={{ cursor: "pointer", fontSize: 23, color: "#000" }}
                  onClick={() => {
                    setOpenApplicantsTests(true);
                    setIdRow(rowData);
                  }}
                />
              </Tooltip>
            )}

            {/* Agregar candidatos */}
            {rowData.status === 1 && (
              <Tooltip title="Agregar candidatos">
                <PersonAdd
                  style={{ cursor: "pointer", fontSize: 23, color: "#000" }}
                  onClick={() => {
                    setOpenApplicants(true);
                    setIdRow(rowData);
                  }}
                />
              </Tooltip>
            )}

            {/* Ver */}
            <Tooltip title="Ver prueba">
              <Search
                style={{ cursor: "pointer", fontSize: 23, color: "#000" }}
                onClick={() => {
                  setOpenView(true);
                  setIdRow(rowData);
                }}
              />
            </Tooltip>

            {/* Editar — solo status 99 */}
            {rowData.status === 99 && (
              <Tooltip title="Editar">
                <Edit
                  style={{ cursor: "pointer", fontSize: 23, color: "#000" }}
                  onClick={(e) => handleOpenTest(e, 2, rowData)}
                />
              </Tooltip>
            )}

            {/* Clave — status 1 o 2 */}
            {(rowData.status === 1 || rowData.status === 2) && (
              <Tooltip title="Clave de acceso">
                <VpnKey
                  style={{ cursor: "pointer", fontSize: 23, color: "#1565c0" }}
                  onClick={() => {
                    setPasswordRow(rowData);
                    setOpenPassword(true);
                  }}
                />
              </Tooltip>
            )}

            {/* Eliminar — solo status 1 */}
            {rowData.status === 1 && (
              <Tooltip title="Eliminar">
                <Cancel
                  style={{ cursor: "pointer", fontSize: 23, color: "#d32f2f" }}
                  onClick={() => {
                    setOpenDesHabilitar(true);
                    setIdRow(rowData);
                  }}
                />
              </Tooltip>
            )}
          </div>
        ),
      },
    ],
  });

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const RefreshTable = () => {
    tableRef.current && tableRef.current.onQueryChange();
  };

  const OpenQuestion = (data) => {
    setIdRow(data);
    setOpenEnableQuestion(true);
  };

  const OpenTestQuestion = (data) => {
    setIdRow(data);
    setOpenTestQuestion(true);
  };

  const handleCloseNew = () => setOpenNew(false);
  const handleCloseView = () => setOpenView(false);
  const handleCloseEdit = () => setOpenEdit(false);
  const handleCloseEnableQuestion = () => setOpenEnableQuestion(false);
  const handleCloseApplicant = () => setOpenApplicants(false);
  const handleCloseTestQuestions = () => setOpenTestQuestion(false);
  const handleCloseDesHabilitar = () => setOpenDesHabilitar(false);
  const handleCloseApplicantsTests = () => setOpenApplicantsTests(false);
  const handleCloseChangeStatus = () => setOpenChangeStatus(false);

  const publishSend = (data, status) => {
    setOpenChangeStatus(true);
    setIdRow({ data: data, status: status });
  };

  const handleOpenTest = (event, option, rowData) => {
    const urlAccount = `${urlServices}accounts/${accountId}`;
    fetch(urlAccount, {
      method: "get",
      headers: {
        application: keyAplication,
        Authorization: "Bearer " + keyAuthorization,
      },
    })
      .then((response) => response.json())
      .then((result) => {
        if (result !== undefined) {
          setActivatePhoto(result.activatePhoto);
          setActivateApplicantreport(result.activateApplicantreport);
          if (option === 1) setOpenNew(true);
          else {
            setIdRow(rowData);
            setOpenEdit(true);
          }
        }
      });
  };

  let url = "";

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="info">
            <div className={classes.cardTitleWhite}>
              <Layers className={classes.iconWhite} /> Gestión de pruebas técnicas
            </div>
          </CardHeader>
          <CardBody>
            <Grid container>
              <Grid item xs={6} sm={6} style={{ fontSize: 16 }}>
                <b>Código institución: </b>{" "}
                <span
                  style={{
                    fontSize: 18,
                    padding: 10,
                    width: 50,
                    background: "rgb(255, 244, 229)",
                    borderRadius: 50,
                    color: "rgb(102, 60, 0)",
                    fontWeight: "bold",
                  }}
                >
                  {accountId}
                </span>
              </Grid>
              <Grid item xs={6} sm={6}>
                <Button
                  className={classes.buttonRight}
                  onClick={(e) => handleOpenTest(e, 1)}
                  startIcon={<AddCircle />}
                >
                  Nueva prueba
                </Button>
              </Grid>
            </Grid>
            <ThemeProvider theme={theme}>
              <MaterialTable
                title=""
                columns={state.columns}
                tableRef={tableRef}
                style={{
                  boxShadow: "unset",
                  border: "1px solid rgb(241, 241, 241)",
                }}
                data={(query) =>
                  new Promise((resolve, reject) => {
                    if (query.search === "") {
                      url = `${urlServices}tests/account/${accountId}?limit=${
                        query.pageSize
                      }&page=${query.page + 1}`;
                    } else {
                      url = `${urlServices}tests/account/${accountId}`;
                    }
                    fetch(url, {
                      method: "get",
                      headers: {
                        application: keyAplication,
                        Authorization: "Bearer " + keyAuthorization,
                      },
                    })
                      .then((response) => response.json())
                      .then((result) => {
                        resolve({
                          data:
                            result.data !== undefined
                              ? result.data.filter(function (obj) {
                                  return Object.keys(obj).some(function (key) {
                                    return obj[key]
                                      ? obj[key]
                                          .toString()
                                          .toLowerCase()
                                          .includes(query.search)
                                      : false;
                                  });
                                })
                              : [],
                          page:
                            result.page !== undefined ? result.page - 1 : 0,
                          totalCount:
                            result.total !== undefined ? result.total : 0,
                        });
                      })
                      .catch((e) => {
                        console.log(e);
                      });
                  })
                }
                localization={{
                  pagination: {
                    labelRowsSelect: "Filas",
                    labelDisplayedRows: " {from}-{to} de {count}",
                    firstTooltip: "Primera página",
                    previousTooltip: "Previo",
                    nextTooltip: "Siguiente",
                    lastTooltip: "Ultima página",
                  },
                  toolbar: {
                    searchTooltip: "Filtrar",
                    searchPlaceholder: "Buscar",
                  },
                  header: {
                    actions: " --- ",
                  },
                  body: {
                    emptyDataSourceMessage: "No hay datos.",
                    filterRow: {
                      filterTooltip: "Filtro",
                    },
                  },
                }}
                actions={[
                  {
                    icon: "refresh",
                    tooltip: "Refresh Data",
                    isFreeAction: true,
                    onClick: () =>
                      tableRef.current && tableRef.current.onQueryChange(),
                  },
                ]}
                icons={tableIcons}
                options={{
                  search: true,
                  padding: "default",
                  filtering: false,
                  actionsColumnIndex: -1,
                  pageSize: 10,
                  headerStyle: {
                    background: "#F2F2F2",
                    padding: "1%",
                    fontWeight: "bold",
                    textAlign: "center",
                  },
                  cellStyle: { border: "1px solid #DDDDDD" },
                }}
                components={{
                  Row: (props) => (
                    <MTableBodyRow className={classes2.tableRow} {...props} />
                  ),
                }}
              />
            </ThemeProvider>
          </CardBody>
        </Card>
      </GridItem>

      {openNew && (
        <NewTestMain
          open={openNew}
          exit={handleCloseNew}
          callBackRefresh={RefreshTable}
          activatePhoto={activatePhoto}
          activateApplicantreport={activateApplicantreport}
        />
      )}
      {openView && (
        <ViewTest open={openView} id={idRow} exit={handleCloseView} />
      )}
      {openEnableQuestion && (
        <Questions
          open={openEnableQuestion}
          exit={handleCloseEnableQuestion}
          id={idRow}
          callBackRefresh={RefreshTable}
        />
      )}
      {openEdit && (
        <EditTest
          open={openEdit}
          exit={handleCloseEdit}
          id={idRow}
          callBackRefresh={RefreshTable}
          activatePhoto={activatePhoto}
          activateApplicantreport={activateApplicantreport}
        />
      )}
      {openApplicants && (
        <EnableApplicantTest
          open={openApplicants}
          exit={handleCloseApplicant}
          id={idRow}
          callBackRefresh={RefreshTable}
        />
      )}
      {openTestQuestion && (
        <TestsQuestions
          open={openTestQuestion}
          exit={handleCloseTestQuestions}
          id={idRow}
        />
      )}
      {openChangeStatus && (
        <ChangeStatusTest
          open={openChangeStatus}
          exit={handleCloseChangeStatus}
          id={idRow}
          callBackRefresh={RefreshTable}
        />
      )}
      {openDesHabilitar && (
        <DisableTest
          open={openDesHabilitar}
          exit={handleCloseDesHabilitar}
          id={idRow}
          callBackRefresh={RefreshTable}
        />
      )}
      {openApplicantsTests && (
        <ViewApplicantTest
          open={openApplicantsTests}
          exit={handleCloseApplicantsTests}
          jobsId={idRow}
        />
      )}
      {openPassword && (
        <TestPassWord
          open={openPassword}
          exit={() => setOpenPassword(false)}
          testId={passwordRow?.id}
          testName={passwordRow?.name}
          testStatus={passwordRow?.status}
        />
      )}
    </GridContainer>
  );
}